function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "23",
  viewBox: "0 0 22 23"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.348 0c1.406 0 2.557.986 2.646 2.233L17 2.39V4h2c1.813 0 3 1.07 3 2v15c0 .93-1.187 2-3 2H8c-1.813 0-3-1.07-3-2l-.001-2H2.652c-1.406 0-2.557-.986-2.646-2.233L0 16.61V2.39C0 1.123 1.094.086 2.478.005L2.652 0h11.696zM19 6H8c-.724 0-1 .242-1 1v13c0 .758.276 1 1 1h11c.724 0 1-.242 1-1V7c0-.758-.276-1-1-1zm-4.652-4.161H2.652c-.304 0-.557.2-.604.462l-.008.09V16.61c0 .274.222.501.513.544l.099.007h2.347L5 6c0-.93 1.187-2 3-2h6.96V2.39c0-.274-.222-.501-.513-.544l-.099-.007zM14 13a1 1 0 010 2h-3a1 1 0 010-2h3zm3-4a1 1 0 010 2h-6a1 1 0 010-2h6z"
}));